<!-- <app-pro-select-header></app-pro-select-header> -->
<!-- <app-pro-partner-details *ngIf="importExists"></app-pro-partner-details> -->
<!-- <app-partner-detail-pro-header [importExists]="importExists"></app-partner-detail-pro-header> -->
<div class="container">
    <app-pro-import-details-table [dataSource]="selectedDataSet" [importExists]="importExists" *ngIf="importExists"></app-pro-import-details-table>
    <div *ngIf="showImportDetails" class="background-container">
        <div class="import-details-container">
            <h1>{{importType}}</h1>
            <h2>{{importYear}} &bull; {{importQuarter}}</h2>
            <button class="btn action-button" (click)="beginProImport()">IMPORT PRO</button>
        </div>
    </div>
</div>